"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
let MembersChooseDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(new APIDataSource("api://base.auth/api/v7/users"));
    this.activeName = "first";
    this.selectDatas = [];
    this.selectLock = false;
    this.searchStr = "";
    this.open_type = "";
    this.rows = [];
    this.searchByName = _.debounce((searchStr) => __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.params = {
          search: `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%';`
        };
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.params = {
          search: `userStatus=='0'`
        };
      }
      this.gridController.query.current = 1;
      yield this.gridController.search();
    }), 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
    this.gridController.query.params = {
      search: `userStatus=='0'`
    };
  }
  open() {
    return __async(this, arguments, function* (selectDatas = []) {
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.gridController.query.sort = "asc";
      this.gridController.query.params = {
        search: `userStatus=='0'`
      };
      this.gridController.search();
      this._distributionDialog.open();
      this.$nextTick(() => {
        for (const item of selectDatas) {
          this._distributionDialog.add(item);
        }
      });
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      this.$emit("saveUsers", data);
      this._distributionDialog.close();
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(this.gridController.result.datas, items, _.isEqual);
      for (const item of items) {
        const _item = {
          id: item["id"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["id"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.id == data2.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = [];
    if (this._distributionDialog) {
      selectDatas = this._distributionDialog.getAll();
    }
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.id == data.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
  close() {
    this.$emit("refresh");
  }
};
__decorateClass([
  Ref("distributionDialog")
], MembersChooseDialog.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], MembersChooseDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(400)
], MembersChooseDialog.prototype, "saved", 1);
MembersChooseDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], MembersChooseDialog);
export {
  MembersChooseDialog as default
};
